import { useMemo } from 'react';
import { Field } from '@atlaskit/form';

import { DatePicker } from '@atlaskit/datetime-picker';
import { formField } from './form-field.styles';

export const FormDatePicker = ({
  id,
  name,
  label,
  disabled,
  defaultValue
}: FormDatePickerProps) => {
  const minDate = useMemo(() => new Date().toISOString(), []);

  return (
    <div css={formField}>
      <Field
        name={name}
        label={label}
        defaultValue={defaultValue ?? minDate}
        isDisabled={disabled}
      >
        {({ fieldProps }) => (
          <DatePicker
            {...fieldProps}
            id={id}
            minDate={minDate}
            selectProps={{ inputId: id }}
          />
        )}
      </Field>
    </div>
  );
};

type FormDatePickerProps = {
  id: string;
  name: string;
  label: string;
  required: boolean;
  disabled: boolean;
  defaultValue?: string;
};
